var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M722 926c-117-32-257-132-410-290C162 480 83 353 72 254c-6-61 6-82 84-147 75-62 91-56 168 60 36 54 66 108 65 121 0 13-11 46-26 72-26 48-26 48 5 88 40 50 209 212 222 212 6 0 20-7 32-15 13-8 39-21 59-30 37-15 37-15 143 54 94 62 106 73 106 99 0 43-93 149-145 167-9 2-37-1-63-9m-47-45c-87-37-193-117-316-241C188 470 99 330 99 234c0-29 9-43 53-85 29-28 61-50 73-50 16 0 37 23 78 85 31 47 56 95 56 108 0 12-11 41-25 63-13 22-24 48-24 58-1 25 251 277 276 276 10 0 37-11 59-24 22-14 50-25 62-25 33-1 193 108 193 131 0 16-35 63-83 111-23 23-85 23-142-1","fill":"#e42f2f","stroke":"#FFF","fillRule":"evenodd"}));
}

Phone.defaultProps = {"className":"prefix__img-fluid","width":"40","height":"40","viewBox":"0 0 1000 1000"};

module.exports = Phone;

Phone.default = Phone;
